import { mediaUrl } from "./api";
import { toast } from "sonner";

// Share the ACTUAL image/video file through the phone's native share sheet, so it lands in
// WhatsApp (chats & groups), Instagram, etc. as a real photo/video — never a link.
export async function shareMediaFile(media) {
  const isVideo = media.type === "video" || media.is_clip;
  const url = mediaUrl(media.id);
  const filename = media.original_filename || (isVideo ? "clip.mp4" : "slide.jpg");

  let file;
  try {
    const resp = await fetch(url, { cache: "no-store" });
    if (!resp.ok) throw new Error("fetch failed");
    const blob = await resp.blob();
    file = new File([blob], filename, { type: blob.type || media.content_type || (isVideo ? "video/mp4" : "image/jpeg") });
  } catch {
    toast.error("Couldn't load the file. Check your connection and try again.");
    return;
  }

  // Preferred path (phones): share the real file → shows up as a photo/video, not a link.
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return; // user cancelled — fine
      // fall through to save
    }
  }

  // Fallback (desktop / unsupported): save the image so it can be attached from the gallery.
  try {
    const objUrl = URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 4000);
    toast.success("Saved. Open WhatsApp and attach it from your Photos/Gallery.");
  } catch {
    toast.error("Could not share on this device.");
  }
}
